<template>
   <div id="app">
      <div class="bg-pilke-dark text-white py-6">
         <div class="container mx-auto">
            <a href="https://pilkepaivakodit.fi">
               <img class="mx-auto block object-contain" width="80" src="./assets/pilke_logo_2x.png" />
            </a>
         </div>
      </div>

      <div v-if="!storeState.applicationSent" class="px-3 container mx-auto">
         <Steps :store="store"></Steps>
      </div>

      <div v-if="storeState.applicationSent" class="px-3 container mx-auto">
         <ThankYou :store="store"></ThankYou>
      </div>
   </div>
</template>

<script>
import Store from './store.js'
import Steps from './components/Steps.vue'
import ThankYou from './views/ThankYou'

export default {
   data () {
      return {
         store: Store,
         storeState: Store.state
      }
   },

   components: {
      Steps,
      ThankYou
   },

   methods: {
      canProceed () {
         return this.storeState.activeStep.success
      }
   }
}
</script>

<style scoped>
</style>
